/*
  Veya: let the Atlas add-to-cart talk to the Be Yours cart drawer.

  The app-served Atlas <product-form> takes `cart-notification || cart-drawer`
  as its cart and then calls getSectionsToRender(), setActiveElement() and
  renderContents() on it. Be Yours' <cart-drawer> (assets/global.js) has none
  of these; they live on <mini-cart> (assets/cart-drawer.js), which sits inside
  the drawer. Without them the submit throws after the button is already
  marked busy, nothing is added and the button stays stuck.

  This adds the three methods to the cart-drawer prototype, so the form's
  cached reference picks them up too, and delegates each to <mini-cart>:
  - getSectionsToRender: mini-cart, cart-icon-bubble, mobile-cart-icon-bubble;
  - renderContents: MiniCart.renderContents swaps those sections in from the
    /cart/add.js response (drawer contents and the header bubble count) and
    opens the drawer. If <mini-cart> is missing or that throws, it falls back
    to Be Yours' own "cart:refresh" event with open: true, which refetches
    the drawer and the bubble and opens the drawer.
  Methods a cart-drawer class already has are never replaced.
*/
(function () {
  if (!window.customElements) return;

  var FALLBACK_SECTIONS = [
    { id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' },
    { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    { id: 'mobile-cart-icon-bubble', section: 'mobile-cart-icon-bubble', selector: '.shopify-section' }
  ];

  function miniCart() {
    var element = document.querySelector('mini-cart');
    return element && typeof element.renderContents === 'function' ? element : null;
  }

  function refreshAndOpen() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
  }

  function patch() {
    var CartDrawer = customElements.get('cart-drawer');
    if (!CartDrawer) return;
    var proto = CartDrawer.prototype;

    if (typeof proto.getSectionsToRender !== 'function') {
      proto.getSectionsToRender = function () {
        var mini = miniCart();
        if (mini && typeof mini.getSectionsToRender === 'function') return mini.getSectionsToRender();
        return FALLBACK_SECTIONS.map(function (section) { return Object.assign({}, section); });
      };
    }

    if (typeof proto.setActiveElement !== 'function') {
      proto.setActiveElement = function (element) {
        this.activeElement = element;
        var mini = miniCart();
        if (mini && typeof mini.setActiveElement === 'function') mini.setActiveElement(element);
      };
    }

    if (typeof proto.renderContents !== 'function') {
      proto.renderContents = function (parsedState) {
        var mini = miniCart();
        if (mini && parsedState && parsedState.sections) {
          try {
            mini.renderContents(parsedState);
            return;
          } catch (error) {
            console.warn('Veya cart bridge: falling back to cart:refresh', error);
          }
        }
        refreshAndOpen();
      };
    }
  }

  customElements.whenDefined('cart-drawer').then(patch);
})();
